const MAX_DIFF_TOKENS = 500;

export function tokenize(text) {
  if (!text) return [];
  return text.match(/\S+|\s+/g) || [];
}

export function computeWordDiff(oldText, newText) {
  const oldTokens = tokenize(oldText || '');
  const newTokens = tokenize(newText || '');
  const m = oldTokens.length;
  const n = newTokens.length;

  if (m > MAX_DIFF_TOKENS || n > MAX_DIFF_TOKENS) {
    const ops = [];
    if (m > 0) ops.push({ type: 'removed', value: oldTokens.join('') });
    if (n > 0) ops.push({ type: 'added', value: newTokens.join('') });
    return ops;
  }

  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      if (oldTokens[i - 1] === newTokens[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1] + 1;
      } else {
        dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
      }
    }
  }

  const ops = [];
  let i = m, j = n;
  while (i > 0 || j > 0) {
    if (i > 0 && j > 0 && oldTokens[i - 1] === newTokens[j - 1]) {
      ops.push({ type: 'equal', value: oldTokens[i - 1] });
      i--; j--;
    } else if (j > 0 && (i === 0 || dp[i][j - 1] >= dp[i - 1][j])) {
      ops.push({ type: 'added', value: newTokens[j - 1] });
      j--;
    } else {
      ops.push({ type: 'removed', value: oldTokens[i - 1] });
      i--;
    }
  }
  ops.reverse();

  const merged = [];
  for (const op of ops) {
    if (merged.length > 0 && merged[merged.length - 1].type === op.type) {
      merged[merged.length - 1].value += op.value;
    } else {
      merged.push({ ...op });
    }
  }
  return merged;
}

export const escHtml = (s) =>
  (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
